<template>
  <div id="auctionFormPage" :class="'popupPage anim' + (open ? ' open' : '')">
    <div v-if="auction != null && open" class="container h-100">
      <div class="row h-100 p-3 p-lg-4">
        <div class="col-md-6 col-lg-12 p-0 h-100 m-auto auctionFormHolder relative">
          <div v-if="page == 'confirm'" class="header">
            <h3 class="m-auto text-orange">{{ $t('home.auction_won_p_title_confirm') }}</h3>
            <a
              @click.prevent="
                open = false
                btnSfx()
              "
              href="#"
              class="close"
            ></a>
          </div>
          <div v-else class="header">
            <h2>{{ $t('home.auction_won_p_title') }}</h2>
            <a
              @click.prevent="
                open = false
                btnSfx()
              "
              href="#"
              class="close"
            ></a>
          </div>

          <div v-if="page == 'form'" class="fromContent p-3">
            <p>{{ $t('home.auction_won_p_subtitle') }}</p>
            <b-form @submit.prevent="onSubmit">
              <div class="row p-lg-5">
                <div class="col-lg-6">
                  <div v-if="'fullName' in form" class="form-group">
                    <label>{{ $t('home.auction_won_p_full_name_label') }} <span v-if="$v.form.fullName.$params.required">*</span></label>
                    <b-form-input v-model="$v.form.fullName.$model" :state="validateState('fullName')"></b-form-input>
                  </div>

                  <div v-if="'personalNumber' in form" class="form-group">
                    <label>{{ $t('home.auction_won_p_personal_number_label') }} <span v-if="$v.form.personalNumber.$params.required">*</span></label>
                    <b-form-input v-model="$v.form.personalNumber.$model" type="number" :state="validateState('personalNumber')"></b-form-input>
                  </div>

                  <div v-if="'msisdn' in form" class="form-group">
                    <label> {{ $t('home.auction_won_p_msisdn_label') }} <span v-if="$v.form.msisdn.$params.required">*</span> </label>
                    <autocomplete-input
                      v-model="$v.form.msisdn.$model"
                      :minQueryLength="0"
                      :fetchOptions="getMsisdns"
                      :state="validateState('msisdn')"
                      :tooltip="{ title: $t(`base.info`), content: $t(`home.autocomplete_tooltip_msisdn`) }"
                    />
                  </div>

                  <div v-if="'municipalityId' in form" class="form-group">
                    <label> {{ $t('home.auction_won_p_municipality_label') }} <span v-if="$v.form.municipalityId.$params.required">*</span> </label>
                    <autocomplete-input
                      v-model="$v.form.municipalityId.$model"
                      :minQueryLength="2"
                      :fetchOptions="getMunicipalities"
                      :state="validateState('municipalityId')"
                      :tooltip="{ title: $t(`base.info`), content: $t(`home.autocomplete_tooltip_municipality`) }"
                    />
                  </div>

                  <div v-if="'localityId' in form" class="form-group">
                    <label> {{ $t('home.auction_won_p_locality_label') }} <span v-if="$v.form.localityId.$params.required">*</span> </label>
                    <autocomplete-input
                      v-model="$v.form.localityId.$model"
                      :minQueryLength="2"
                      :fetchOptions="getLocalities"
                      :state="validateState('localityId')"
                      :tooltip="{ title: $t(`base.info`), content: $t(`home.autocomplete_tooltip_place`) }"
                    />
                  </div>

                  <div v-if="'streetId' in form" class="form-group row">
                    <div class="col-7">
                      <label>{{ $t('home.auction_won_p_street_name_label') }} <span v-if="$v.form.streetId.$params.required">*</span></label>
                      <autocomplete-input
                        v-model="$v.form.streetId.$model"
                        :minQueryLength="2"
                        :fetchOptions="getStreets"
                        :state="validateState('streetId')"
                        :tooltip="{ title: $t(`base.info`), content: $t(`home.autocomplete_tooltip_street`) }"
                      />
                    </div>
                    <div class="col-5">
                      <label>{{ $t('home.auction_won_p_street_number_label') }} <span v-if="$v.form.streetNumberId.$params.required">*</span></label>
                      <autocomplete-input
                        v-model="$v.form.streetNumberId.$model"
                        :minQueryLength="1"
                        :fetchOptions="getStreetNumbers"
                        :state="validateState('streetNumberId')"
                      />
                    </div>
                  </div>

                  <div v-if="'streetName' in form" class="form-group row">
                    <div class="col-7">
                      <label>{{ $t('home.auction_won_p_street_name_label') }} <span v-if="$v.form.streetName.$params.required">*</span></label>
                      <b-form-input v-model="$v.form.streetName.$model" :state="validateState('streetName')"></b-form-input>
                    </div>
                    <div class="col-5">
                      <label>{{ $t('home.auction_won_p_street_number_label') }} <span v-if="$v.form.streetNumber.$params.required">*</span></label>
                      <b-form-input v-model="$v.form.streetNumber.$model" :state="validateState('streetNumber')"></b-form-input>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group row">
                    <div v-if="'streetSubnumber' in form" class="col">
                      <label>{{ $t('home.auction_won_p_street_subnumber_label') }} <span v-if="$v.form.streetSubnumber.$params.required">*</span></label>
                      <b-form-input v-model="$v.form.streetSubnumber.$model" :state="validateState('streetSubnumber')"></b-form-input>
                    </div>
                    <div v-if="'floorNumber' in form" class="col">
                      <label>{{ $t('home.auction_won_p_floor_number_label') }} <span v-if="$v.form.floorNumber.$params.required">*</span></label>
                      <b-form-input v-model="$v.form.floorNumber.$model" :state="validateState('floorNumber')"></b-form-input>
                    </div>
                    <div v-if="'apartmentNumber' in form" class="col">
                      <label>{{ $t('home.auction_won_p_apartment_number_label') }} <span v-if="$v.form.apartmentNumber.$params.required">*</span></label>
                      <b-form-input v-model="$v.form.apartmentNumber.$model" :state="validateState('apartmentNumber')"></b-form-input>
                    </div>
                  </div>

                  <div v-if="'place' in form" class="form-group">
                    <label>{{ $t('home.auction_won_p_place_label') }} <span v-if="$v.form.place.$params.required">*</span></label>
                    <b-form-input v-model="$v.form.place.$model" :state="validateState('place')"></b-form-input>
                  </div>

                  <div v-if="'municipality' in form" class="form-group mb-4">
                    <label>{{ $t('home.auction_won_p_municipality_label') }} <span v-if="$v.form.municipality.$params.required">*</span></label>
                    <b-form-input v-model="$v.form.municipality.$model" :state="validateState('municipality')"></b-form-input>
                  </div>

                  <div v-if="'terms' in form" class="form-group text-left">
                    <b-form-checkbox v-model="$v.form.terms.$model" :state="validateState('terms')">
                      <div class="d-inline">{{ $t('home.auction_won_p_privacy_label') }}</div>
                      <div class="d-inline" v-html="$t('base.link_terms_and_privacy')"></div>
                    </b-form-checkbox>
                  </div>
                </div>
              </div>

              <div v-if="edit" class="w-100 mt-4 mb-3">
                <b-button type="submit" variant="primary" class="pl-4 pr-4">{{ $t('base.btn_continue') }}</b-button>
              </div>

              <div v-if="!edit" class="w-100 mt-4 mb-3">
                <b-button type="submit" @click="btnSfx" variant="primary">
                  {{ $t('home.auction_won_p_submit_btn') }}
                </b-button>
              </div>
              <div v-if="!edit" class="w-100 mb-2">
                <a
                  href="#"
                  @click="
                    hide()
                    btnSfx()
                  "
                  >{{ $t('base.btn_cancel') }}</a
                >
              </div>
            </b-form>
          </div>

          <div v-if="page == 'confirm'" class="fromContent">
            <div class="confirmRow">
              <label>{{ $t('home.auction_won_p_full_name_label') }}</label>
              <p class="mb-0">{{ form.fullName }}</p>
            </div>

            <div class="confirmRow">
              <label>{{ $t('home.auction_won_p_personal_number_label') }}</label>
              <p class="mb-0">{{ form.personalNumber }}</p>
            </div>

            <div v-if="'msisdn' in form" class="confirmRow">
              <label>{{ $t('home.auction_won_p_msisdn_label') }}</label>
              <p class="mb-0">{{ form.msisdn.name }}</p>
            </div>

            <div class="confirmRow row">
              <div class="col-7">
                <label>{{ $t('home.auction_won_p_street_name_label') }}</label>
                <p class="mb-0">{{ 'streetId' in form ? form.streetId.name : form.streetName }}</p>
              </div>
              <div class="col-5">
                <label>{{ $t('home.auction_won_p_street_number_label') }}</label>
                <p class="mb-0">{{ 'streetNumberId' in form ? form.streetNumberId.name : form.streetNumber }}</p>
              </div>
            </div>

            <div class="confirmRow row">
              <div v-if="'streetSubnumber' in form" class="col">
                <label>{{ $t('home.auction_won_p_street_subnumber_label') }}</label>
                <p class="mb-0">{{ form.streetSubnumber }}</p>
              </div>
              <div class="col">
                <label>{{ $t('home.auction_won_p_floor_number_label') }}</label>
                <p class="mb-0">{{ form.floorNumber }}</p>
              </div>
              <div class="col">
                <label>{{ $t('home.auction_won_p_apartment_number_label') }}</label>
                <p class="mb-0">{{ form.apartmentNumber }}</p>
              </div>
            </div>

            <div v-if="'place' in form" class="confirmRow">
              <label>{{ $t('home.auction_won_p_place_label') }}</label>
              <p class="mb-0">{{ form.place }}</p>
            </div>

            <div class="confirmRow">
              <label>{{ $t('home.auction_won_p_municipality_label') }}</label>
              <p class="mb-0">{{ 'municipalityId' in form ? form.municipalityId.name : form.municipality }}</p>
            </div>

            <div v-if="'localityId' in form" class="confirmRow">
              <label>{{ $t('home.auction_won_p_locality_label') }}</label>
              <p class="mb-0">{{ form.localityId.name }}</p>
            </div>

            <div class="w-100 p-3">
              <i class="fas fa-exclamation-triangle text-orange mb-2" style="font-size: 2rem"></i>
              <div class="pl-4 pr-4">
                <b>{{ $t('home.auction_won_p_descriptin_confirm') }}</b>
              </div>
            </div>

            <div class="w-100">
              <b-button
                @click="
                  page = 'form'
                  btnSfx()
                "
                type="button"
                variant="danger"
              >
                <i class="fas fa-arrow-left"></i> {{ $t('home.auction_won_p_confirm_back_btn') }}
              </b-button>
              <b-button
                @click="
                  confirm()
                  btnSfx()
                "
                type="button"
                variant="primary"
              >
                <i class="fas fa-check"></i> {{ $t('home.auction_won_p_confirm_btn') }}
              </b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import api from '../../api'

import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
import AutocompleteInput from '../ui/AutocompleteInput.vue'

const AuctionFormPopup = Vue.component('auction-form-popup', {
  mixins: [validationMixin, AutocompleteInput],
  data() {
    return {
      page: 'form',
      auction: null,
      payment: null,
      open: false,
      edit: false,
      form: {},
      msisdnList: [],
    }
  },

  validations() {
    const rules = {
      form: {
        fullName: {
          required,
          minLength: minLength(3),
        },
        msisdn: {
          required: this.user.mtsCustomer,
        },
        municipalityId: {
          required: this.user.mtsCustomer,
        },
        localityId: {
          required: this.user.mtsCustomer,
        },
        streetId: {
          required: this.user.mtsCustomer,
        },
        streetNumberId: {
          required: this.user.mtsCustomer,
        },

        streetName: {
          required: !this.user.mtsCustomer,
          maxLength: maxLength(200),
        },
        streetNumber: {
          required: !this.user.mtsCustomer,
          maxLength: maxLength(10),
        },
        streetSubnumber: {
          maxLength: maxLength(10),
        },
        floorNumber: {
          maxLength: maxLength(10),
        },
        apartmentNumber: {
          maxLength: maxLength(10),
        },

        personalNumber: {
          required,
          numeric,
          minLength: minLength(13),
          maxLength: maxLength(13),
        },

        place: {
          required: !this.user.mtsCustomer,
          maxLength: maxLength(50),
        },

        municipality: {
          maxLength: maxLength(50),
        },

        terms: {
          accepted: (val) => val === true,
        },
      },
    }

    return rules
  },

  computed: {
    user() {
      return this.$store.state.auth.user
    },
  },

  methods: {
    btnSfx() {
      this.$store.dispatch('sound/sfx', 'Button')
    },

    validateState(name) {
      const { $dirty, $error } = name.split('.').reduce((r, val) => {
        return r ? r[val] : undefined
      }, this.$v.form)
      return $dirty ? !$error : null
    },

    resetForm() {
      this.form = this.user.mtsCustomer
        ? {
            fullName: '',
            personalNumber: '',
            floorNumber: '',
            apartmentNumber: '',
            msisdn: null,
            municipalityId: null,
            localityId: null,
            streetId: null,
            streetNumberId: null,
            terms: false,
          }
        : {
            fullName: '',
            personalNumber: '',
            streetName: '',
            streetNumber: '',
            streetSubnumber: '',
            floorNumber: '',
            apartmentNumber: '',
            place: '',
            municipality: '',
            terms: false,
          }

      this.$nextTick(() => {
        let myDiv = document.querySelector('.auctionFormHolder .fromContent')
        if (myDiv != undefined) myDiv.scrollTop = 0
        this.$v.$reset()
      })
    },

    onSubmit() {
      this.$v.form.$touch()
      if (this.$v.form.$anyError) return

      this.page = 'confirm'
    },

    confirm() {
      const $this = this
      this.$v.form.$touch()
      if (this.$v.form.$anyError) return

      let data = { ...this.form }

      if (this.user.mtsCustomer) {
        data['municipality'] = data['municipalityId'].name
        data['place'] = data['localityId'].name
        data['streetName'] = data['streetId'].name
        data['streetNumber'] = data['streetNumberId'].name
      }

      // remove empty
      for (let d in data) {
        if (data[d] == '') data[d] = undefined
        if (['msisdn', 'municipalityId', 'localityId', 'streetId', 'streetNumberId'].includes(d)) {
          data[d] = data[d].value
        }
      }

      if (this.edit) data['update'] = 1

      data['auctionId'] = this.auction.id

      const request = this.edit ? api.updateAuctionRequest(data) : api.createAuctionRequest(data)
      request
        .then((response) => {
          $this.$root.$emit('updateAuctionRequest')
          $this.hide()
        })
        .catch((error) => {
          api.baseErrorHendler(error)
        })
    },

    show(obj) {
      this.auction = obj
      this.page = 'form'
      this.open = true
      this.edit = obj.paymentStatus === 'ERROR'
      this.resetForm()

      if (this.user.mtsCustomer) {
        api.msisdns().then((res) => {
          res.data = res.data.map((d) => {
            return { value: d, name: d }
          })
          this.msisdnList = res.data
          return res
        })
      }
    },

    openEditForm() {
      this.page = 'form'
      this.open = true
      this.edit = true
      this.resetForm()
    },

    hide() {
      this.open = false
    },

    getMsisdns(search) {
      return new Promise((resolve) => {
        if ((search ?? '').trim() === '') resolve({ data: this.msisdnList })
        else resolve({ data: this.msisdnList.filter((item) => item.name.toLowerCase().includes(search.toLowerCase())) })
      })
    },
    getMunicipalities(search) {
      return api.addressesMunicipalities(search).then((res) => {
        res.data = res.data.map((d) => {
          return { value: d.id, name: d.name }
        })
        return res
      })
    },
    getLocalities(search) {
      if (!this.form.municipalityId.value) return
      return api.addressesLocalities(this.form.municipalityId.value, search).then((res) => {
        res.data = res.data.map((d) => {
          return { value: d.id, name: d.name }
        })
        return res
      })
    },
    getStreets(search) {
      if (!this.form.localityId.value) return
      return api.addressesStreets(this.form.municipalityId.value, this.form.localityId.value, search).then((res) => {
        res.data = res.data.map((d) => {
          return { value: d.id, name: [d.name, d?.suburb].join(', ') }
        })
        return res
      })
    },
    getStreetNumbers(search) {
      if (!this.form.streetId.value) return
      return api.addressesStreetNumbers(this.form.municipalityId.value, this.form.streetId.value, search).then((res) => {
        res.data = res.data.map((d) => {
          return { value: d.id, name: [d.ordinal, d.suffix === '/' ? null : d.suffix].join(' ') }
        })
        return res
      })
    },
  },

  watch: {
    'form.municipalityId': {
      handler(newVal, oldVal) {
        if (newVal?.value === oldVal?.value) return
        this.form.localityId = null
        this.$v.form.localityId.$model = null
        this.$v.$reset()
      },
      deep: true,
    },

    open() {
      document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
      document.body.scrollTop = 0 // For Safari
      if (this.open) document.body.classList.add('lock')
      else document.body.classList.remove('lock')
    },
  },
})

export default AuctionFormPopup
</script>
